import { Fragment } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Breadcrumbs, Btn } from "../../../AbstractElements";
import {
  Col,
  Container,
  Row,
  Spinner
} from "reactstrap";
import { useDataFetch } from "../../Hooks/Use-data-fetch";

// Componentes individuales
import { CardUserInfo } from "../../Components/user/CardUserInfo";
import { CardUserWallet } from "../../Components/user/CardUserWallet";
import { CardUserNetwork } from "../../Components/user/CardUserNetwork";
import { CardUserBankAccount } from "../../Components/user/CardUserBankAccount";

export const DetailUser = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { getData } = useDataFetch();

  const { data, isLoading } = getData(["user", id], `/users/byId/${id}`, {
    enabled: !!id,
  });

  const user = data?.data?.user;

  if (isLoading) {
    return (
      <div className="text-center py-5">
        <Spinner color="primary" /> Cargando usuario...
      </div>
    );
  }

  if (!user) {
    return (
      <div className="text-center py-5">
        <h5>No se encontró el usuario</h5>
        <Btn attrBtn={{ color: "primary", onClick: () => navigate(-1) }}>
          <i className="fa fa-arrow-left me-1" />
          Volver
        </Btn>
      </div>
    );
  }

  return (
    <Fragment>
      <Breadcrumbs parent="Usuarios" title="Detalle Usuario" mainTitle="Detalle del Usuario" />
      <Container fluid className="user-detail-page py-3">
        {/* Botón volver arriba */}
        <div className="mb-3">
          <Btn attrBtn={{ color: "light", onClick: () => navigate(-1) }}>
            <i className="fa fa-arrow-left me-1" />
            Volver
          </Btn>
        </div>

        {/* Información principal */}
        <Row className="gy-4">
          <Col xl="6" lg="6">
            <CardUserInfo user={user} />
          </Col>

          <Col xl="6" lg="6">
            <CardUserBankAccount user={user} />
          </Col>

          <Col xl="12" lg="12">
            <CardUserNetwork network={user.user_network} />
          </Col>
        </Row>

        {/* Información adicional */}
        <Row className="gy-4 mt-4">
          <Col lg="12">
            <CardUserWallet wallet={user.network?.wallet} />
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};
